import video from 'assets/img/homepage/introduce-bg.mp4'
import logo from 'assets/img/logo-short.svg'

const HomepageIntroduce = () => {
  return (
    <div className='homepage-introduce' id='introduce'>
      <video src={video} autoPlay playsInline muted loop className='homepage-introduce__video'></video>
      <section className='homepage-introduce__first'>
        <h2 className='homepage__second-title'>
          You're here early - nice move! Send us an email if you would like a personal invitation with special Day 1 incentives at:
        </h2>
      </section>
      <section className='homepage-introduce__second'>
        <h2 className='homepage__second-title'>
          {/* If something breaks, glitches or vanishes into the void - let us know! */}
          <a href="mailto:support@twotwentyk.io" className="homepage__second-title-link">support@twotwentyk.io</a>
        </h2>
        <img src={logo} className='homepage-introduce__logo' alt="" />
      </section>
    </div>
  )
}

export default HomepageIntroduce;
